<template>
    <div class="h-screen overflow-hidden">
        <div :class="(edit || add)?'large:grid-cols-2 small:grid-cols-1':'grid-cols-1'" class="grid auto-cols-auto p-4 bg-[#23242A] text-white h-screen overflow-y-auto">
            <div class="w-full">
                <block-loading v-if="table.loading" />
                <div v-else class="rounded-[10px] bg-[#2B2C32] w-full">
                    <div class="text-[24px] text-white font-semibold px-4 pt-4">
                        <div class="flex justify-between">
                            <span>Security Roles</span>
                            <button class="text-white bg-theme-green hover:bg-green-600 py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer" @click.prevent="createSecurityRole">
                                <span>
                                    <svg fill="currentColor" width="32" height="32" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"></path>
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div class="table w-full mt-6 px-2 pb-4">
                        <table-lite
                            :is-loading="table.loading"
                            :is-static-mode="true"
                            :is-hide-paging="true"
                            :class="'block w-full admin-table admin-table-custom'"
                            :rowClasses="row => row?row.id.toString():null"
                            :columns="table.columns"
                            :rows="table.rows"
                            :sortable="table.sortable"
                            :total="table.rows.length"
                            @do-search="doSearch"
                            @row-clicked="selectedRow"
                            :messages="{
                                gotoPageLabel: 'Go to page',
                                noDataAvailable: 'No records found!',
                            }"
                        >
                        </table-lite>
                    </div>
                </div>
            </div>
            <div v-if="edit || add" class="w-full large:px-4  pb-52">
                <edit-security-role v-if="edit" :editItem="editItem" @edited="edited" @close="closeEdit" />
                <add-security-role v-if="add" @added="added" @close="closeAdd" />
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, reactive } from "vue";
import EditSecurityRole from './EditSecurityRole.vue'
import AddSecurityRole from './AddSecurityRole.vue'
import SecurityRoleApi from "@/controllers/RoleApis";
import { mapMutations } from "vuex";


export default defineComponent({
    components: {
        AddSecurityRole,
        EditSecurityRole
    },
    setup(){
        // table
        const table = reactive({
            loading: true,
            columns: [
                {label: 'Role', field:'role', sortable: true, isKey: true},
                {label: 'Description', field:'description', sortable: true}
            ],
            rows: [],
            sortable: {
                order: "role",
                sort: "asc",
            }
        })

        //edit
        const edit = ref(false)
        const editItem = ref()

        const add = ref(false)

        return {table, add, edit, editItem}
    },
    mounted(){
        this.edit = false
        this.getData()
    },
    methods: {
        async getData(){
            this.table.loading = true
            let {data: {payload}} = await SecurityRoleApi.getAllRoles()

            this.table.rows = payload
            this.table.loading = false
        },
        selectedRow(item){
            // selection effect
             let activeRow = document.getElementsByClassName(item.id);
             if(activeRow[0] && activeRow[0].parentNode && activeRow[0].parentNode.children){
                for(let sibling of activeRow[0].parentNode.children){
                    sibling.classList.remove('active-row')
                }
             }
             activeRow[0].classList.add("active-row")

            // action
            this.add = false
            this.edit = true
            this.editItem = item
        },
        edited(){
            this.closeEdit()
            this.getData()
        },
        closeEdit(){
            this.edit = false
            this.add = false
        },
        createSecurityRole(){
            this.add = true
            this.edit = false
        },
        added(){
            this.closeAdd()
            this.getData()
        },
        closeAdd(){
            this.add = false
            this.edit = false
        },
        ...mapMutations({
            vm_spinner: 'spinner/mutateSpinner'
        })
    }
})
</script>